import * as types from "../mutation-type"
import axios from "axios/index";


export default {
  state: {
    paper16: {
      info:[]
    },
    paper17: {
      info:[]
    },
    paper18: {
      info:[]
    },
    paper19: {
      info:[]
    },
    paper20: {
      info:[]
    },
    paper21: {
      info:[]
    },
    paper22: {
      info:[]
    },
    paper23: {
      info:[]
    },
    paper24: {
      info:[]
    },
    paper25: {
      info:[]
    },
  },
  mutations: {
    [types.SET_PAPER_16](state, payload) {
      state.paper16.info = payload.info
    },
    [types.SET_PAPER_17](state, payload) {
      state.paper17.info = payload.info
    },
    [types.SET_PAPER_18](state, payload) {
      state.paper18.info = payload.info
    },
    [types.SET_PAPER_19](state, payload) {
      state.paper19.info = payload.info
    },
    [types.SET_PAPER_20](state, payload) {
      state.paper20.info = payload.info
    },
    [types.SET_PAPER_21](state, payload) {
      state.paper21.info = payload.info
    },
    [types.SET_PAPER_22](state, payload) {
      state.paper22.info = payload.info
    },
    [types.SET_PAPER_23](state, payload) {
      state.paper23.info = payload.info
    },
    [types.SET_PAPER_24](state, payload) {
      state.paper24.info = payload.info
    },
    [types.SET_PAPER_25](state, payload) {
      state.paper25.info = payload.info
    },
  },
  actions: {
    getPaper16({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "paper/list/2016"
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_PAPER_16,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },
    getPaper17({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "paper/list/2017"
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_PAPER_17,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },
    getPaper18({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "paper/list/2018"
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_PAPER_18,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },
    getPaper19({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "paper/list/2019"
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_PAPER_19,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },
    getPaper20({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "paper/list/2020"
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_PAPER_20,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },
    getPaper21({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "paper/list/2021"
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_PAPER_21,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },
    getPaper22({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "paper/list/2022"
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_PAPER_22,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },
    getPaper23({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "paper/list/2023"
      // console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        // console.log(data)
        commit({
          type: types.SET_PAPER_23,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },
    getPaper24({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "paper/list/2024"
      // console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        // console.log(data)
        commit({
          type: types.SET_PAPER_24,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },

    getPaper25({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "paper/list/2025"
      // console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        // console.log(data)
        commit({
          type: types.SET_PAPER_25,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },

  }
}
